export const company = {
  owner: 'Moussa Diawara',
  trade: 'Artisan serrurier',
  siren: '841 169 105',
  address: '35 rue de Paris',
  postalCode: '78600',
  city: 'Maisons-Laffitte',
  phone: '06 12 34 56 78',
  phoneHref: 'tel:+33612345678',
  email: 'contact@serrurier-diawara.fr',
  hours: 'Interventions 7j/7, de 7h à 22h',
  since: 2018,
}
